import React from 'react'
import { Button } from '@mui/material'
import AppDialog from './AppDialog'

function ConfirmDialog({ open, title = 'Confirm action', message, onCancel, onConfirm, confirmLabel = 'Confirm' }) {
    return (
        <AppDialog
            open={open}
            onClose={onCancel}
            title={title}
            actions={
                <>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button variant='contained' color='error' onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </>
            }>
            {message}
        </AppDialog>
    )
}

export default ConfirmDialog
